module.exports = __webpack_public_path__ + "img/slide_background_sample.79062c7f.png";